import { render, staticRenderFns } from "./ttdSuratKeluar.vue?vue&type=template&id=70e71032"
import script from "./ttdSuratKeluar.vue?vue&type=script&lang=js"
export * from "./ttdSuratKeluar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QIcon,QList,QItemLabel,QItem,QItemSection,QMenu,QDialog,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QIcon,QList,QItemLabel,QItem,QItemSection,QMenu,QDialog,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
